import React from 'react';


const PaymentListEmpty = () => (
  <div className="billetContainer">
    <div className="title-1 elementDummy" />
    <div className="title-2 elementDummy" />
    <div className="title-2 elementDummy" />
    <div className="title-2 elementDummy" />
    <div className="title-2 elementDummy" />
  </div>
);

export default PaymentListEmpty;
